import { RangeSlider } from './RangeSlider';

export * from './RangeSlider';

export default RangeSlider;
